'use client';

import React from 'react';
import styled from 'styled-components';
import { Text, useUi } from '@weareconceptstudio/core';
import Button from '@/components/Button';

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	text-align: center;

	.cmwp-title {
		text-align: center;
	}

	.cmwp-removed {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: var(--sp1x);
		margin-top: var(--sp3x);
	}

	.cmwp-removed-list {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: var(--sp1x);
		margin: 0;
		padding: 0;
		list-style: none;
	}

	.cmwp-actions {
		display: flex;
		justify-content: center;
		align-items: center;
		gap: var(--sp5x);
		margin-top: var(--sp7x);
	}
`;

/**
 * Branch-change confirmation popup that also lists the items that will be
 * removed (parity with the mobile CartModifiedModal). The packaged
 * CartModificationWarningPopup only renders a title, so we render our own body
 * while reusing the shared `.cart-modification-warning-popup` container styles.
 */
const CartModifiedWarningPopup = ({
	onConfirm,
	removedItemNames = [],
	titleKey = 'deliveryTemplate.cartModifiedTitle',
}) => {
	const { closePopup } = useUi();

	return (
		<Wrapper>
			<Text
				tag='h6'
				className='cmwp-title h6 font-montserrat-arm-medium background-color'
				text={titleKey}
			/>

			{removedItemNames.length > 0 && (
				<div className='cmwp-removed'>
					<Text
						className='p p4 font-montserrat-arm-regular background-color'
						text='deliveryTemplate.cartModifiedRemovedItems'
					/>
					<ul className='cmwp-removed-list'>
						{removedItemNames.map((name, index) => (
							<li key={`${name}-${index}`}>
								<Text className='p p4 font-montserrat-arm-medium background-color'>
									{`• ${name}`}
								</Text>
							</li>
						))}
					</ul>
				</div>
			)}

			<div className='cmwp-actions'>
				<Button
					btnType='text-link'
					className='cmwp-cancel'
					text='deliveryTemplate.cancel'
					onClick={closePopup}
				/>
				<Button
					btnType='reverse'
					className='cmwp-confirm'
					text='deliveryTemplate.confirm'
					onClick={() => {
						closePopup();
						onConfirm?.();
					}}
				/>
			</div>
		</Wrapper>
	);
};

export default CartModifiedWarningPopup;
